module.exports = __webpack_public_path__ + "static/media/Image-118.8616ce44.png";